(() => {
  const panel = document.querySelector('[data-filter-panel]');
  const openButton = document.querySelector('[data-filter-open]');
  if (!panel || !openButton) return;

  const desktop = window.matchMedia('(min-width: 900px)');
  let scrim = null;

  const close = () => {
    delete panel.dataset.open;
    document.body.style.overflow = '';
    scrim?.remove();
    scrim = null;
    openButton.focus();
  };

  const open = () => {
    panel.dataset.open = 'true';
    document.body.style.overflow = 'hidden';
    scrim = document.createElement('button');
    scrim.className = 'col__scrim';
    scrim.setAttribute('aria-label', 'Close filters');
    scrim.addEventListener('click', close);
    document.body.appendChild(scrim);
    panel.querySelector('[data-filter-close]')?.focus();
  };

  openButton.addEventListener('click', open);
  panel.querySelector('[data-filter-close]')?.addEventListener('click', close);

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && panel.dataset.open) close();
  });

  // Leaving the drawer open while resizing to desktop would trap scrolling.
  desktop.addEventListener('change', (event) => {
    if (event.matches && panel.dataset.open) close();
  });

  // Sorting submits immediately; filters wait for Apply so shoppers can pick
  // several without a reload between each one.
  document.querySelector('[data-auto-submit]')?.addEventListener('change', (event) => {
    event.target.form.submit();
  });

  // Only one filter dropdown open at a time, and clicking away closes it.
  const drops = [...document.querySelectorAll('[data-fdrop]')];

  drops.forEach((drop) => {
    drop.addEventListener('toggle', () => {
      if (!drop.open) return;
      drops.filter((other) => other !== drop).forEach((other) => { other.open = false; });
    });
  });

  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-fdrop]')) return;
    drops.forEach((drop) => { drop.open = false; });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') drops.forEach((drop) => { drop.open = false; });
  });

  // ---------- paging without a page load ----------

  // Only the grid changes between pages, so only the grid is fetched. A full
  // navigation throws away the header, menu, drawer and footer and rebuilds
  // them identically, which is the flash between pages.
  const results = document.querySelector('[data-results]');
  const section = document.querySelector('.col')?.dataset.sectionId;

  if (results && section && 'fetch' in window && 'replaceState' in history) {
    const cache = new Map();

    const grab = (url) => {
      if (cache.has(url)) return cache.get(url);

      const target = new URL(url, window.location.origin);
      target.searchParams.set('section_id', section);

      const pending = fetch(target.href)
        .then((response) => (response.ok ? response.text() : Promise.reject(response.status)))
        .then((html) => new DOMParser().parseFromString(html, 'text/html').querySelector('[data-results]'))
        .then((fresh) => {
          if (!fresh) throw new Error('no results block in the response');
          return fresh.innerHTML;
        });

      cache.set(url, pending);
      return pending;
    };

    const settle = () => {
      // Land just under the sticky toolbar rather than at the very top, so the
      // first row is the first thing read.
      const bar = document.querySelector('[data-toolbar]');
      const offset = (bar?.getBoundingClientRect().height || 0) + (parseFloat(
        getComputedStyle(document.documentElement).getPropertyValue('--header-h')
      ) || 96);

      const top = results.getBoundingClientRect().top + window.scrollY - offset - 12;
      window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    };

    const show = async (url, push) => {
      results.dataset.busy = 'true';

      try {
        results.innerHTML = await grab(url);
      } catch (error) {
        // A page that cannot be fetched is still a page that can be visited.
        window.location.href = url;
        return;
      }

      delete results.dataset.busy;
      if (push) history.pushState({ paged: true }, '', url);
      settle();
      results.querySelector('.pcard a')?.focus({ preventScroll: true });
    };

    // Delegated, because the pager is inside the block being replaced.
    results.addEventListener('click', (event) => {
      const link = event.target.closest('.pager__page, .pager__step');
      if (!link || link.tagName !== 'A') return;
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) return;

      event.preventDefault();
      show(link.href, true);
    });

    // Warm the next page while the shopper is still deciding.
    results.addEventListener('pointerenter', (event) => {
      const link = event.target.closest?.('.pager__page, .pager__step');
      if (link && link.tagName === 'A') grab(link.href).catch(() => {});
    }, true);

    window.addEventListener('popstate', (event) => {
      if (event.state?.paged) show(window.location.href, false);
    });

    // So the first Back press returns to this page rather than leaving.
    history.replaceState({ paged: true }, '', window.location.href);
  }

  // Brand lists run past a hundred names in the big departments, so they are
  // typed down rather than scrolled. Filtering is local: every brand in the
  // collection is already in the DOM.
  document.querySelectorAll('[data-brand-search]').forEach((input) => {
    const scope = input.closest('.fdrop__panel, .facet');
    const list = scope?.querySelector('[data-brand-list]');
    const empty = scope?.querySelector('[data-brand-empty]');
    if (!list) return;

    const items = [...list.querySelectorAll('[data-brand]')];

    const apply = () => {
      const query = input.value.trim().toLowerCase();
      let shown = 0;

      items.forEach((item) => {
        // Prefix first, then anywhere, so "la roche" finds the brand and
        // "roche" still does.
        const hit = query === '' || item.dataset.brand.includes(query);
        item.hidden = !hit;
        if (hit) shown += 1;
      });

      if (empty) empty.hidden = shown > 0;
    };

    input.addEventListener('input', apply);

    // Enter on a single remaining match goes straight there.
    input.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter') return;
      event.preventDefault();
      const first = items.find((item) => !item.hidden);
      if (first) window.location.href = first.href;
    });
  });
})();
